/**
 * Magyar nyelvi string táblák.
 * V1: csak HU, EN előkészítve egy későbbi locale fájl hozzáadásával.
 */

export const hu = {
  app: {
    name: 'Adaptivo Számlakezelő',
    tagline: 'NAV integráció + céges pénzügyi kontroll',
  },
  nav: {
    invoices: 'Számlák',
    discrepancies: 'Eltérések',
    monthlyClose: 'Havi zárás',
    costBreakdown: 'Költségbontás',
    banking: 'Banki tételek',
    inbox: 'Beérkező',
    settings: 'Beállítások',
    auditLog: 'Audit log',
    logout: 'Kilépés',
  },
  invoiceStatus: {
    received: 'Beérkezett',
    waiting_for_nav: 'NAV-ra vár',
    matched: 'Párosítva',
    discrepancy: 'Eltéréses',
    under_review: 'Ellenőrzés alatt',
    approval_pending: 'Jóváhagyásra vár',
    approved: 'Jóváhagyva',
    handed_to_accountant: 'Könyvelőnek átadva',
    booked: 'Könyvelve',
    payment_pending: 'Fizetésre vár',
    paid: 'Fizetve',
    disputed: 'Vitás',
    rejected: 'Elutasított',
    archived: 'Archivált',
  },
  matchingStatus: {
    pending: 'Várakozik',
    matched: 'NAV+PDF egyezik',
    nav_only: 'Csak NAV',
    doc_only: 'Csak dokumentum',
    foreign_no_nav: 'Külföldi (NAV nélkül)',
    amount_mismatch: 'Összegeltérés',
    number_mismatch: 'Számlaszám eltér',
    tax_id_mismatch: 'Adószám eltér',
    manual_review: 'Kézi ellenőrzés',
    duplicate_suspect: 'Duplikáció gyanú',
    modification_or_cancel: 'Módosító / sztornó',
  },
  paymentStatus: {
    unpaid: 'Fizetetlen',
    partially_paid: 'Részben fizetve',
    paid: 'Fizetve',
    overdue: 'Lejárt',
    not_applicable: '—',
  },
  source: {
    nav: 'NAV',
    email: 'Email',
    manual: 'Manuális',
  },
  countryType: {
    HU: 'Belföldi',
    EU: 'EU-s',
    THIRD_COUNTRY: '3. ország',
    UNKNOWN: 'Ismeretlen',
  },
  direction: {
    incoming: 'Bejövő',
    outgoing: 'Kimenő',
  },
  vatCategory: {
    domestic_deductible: 'Belföldi levonható',
    domestic_non_deductible: 'Belföldi nem levonható',
    domestic_reverse_charge: 'Belföldi fordított ÁFA',
    eu_acquisition: 'EU közösségi beszerzés',
    eu_reverse_charge: 'EU fordított ÁFA',
    third_country_import: '3. ország import',
    vat_exempt_subjective: 'Alanyi mentes',
    vat_exempt_objective: 'Tárgyi mentes',
    out_of_scope: 'ÁFA-hatályán kívül',
    needs_review: 'Felülvizsgálandó',
  },
  common: {
    save: 'Mentés',
    cancel: 'Mégse',
    close: 'Bezár',
    edit: 'Szerkeszt',
    delete: 'Töröl',
    archive: 'Archivál',
    approve: 'Jóváhagy',
    reject: 'Elutasít',
    upload: 'Feltöltés',
    download: 'Letöltés',
    search: 'Keresés',
    filter: 'Szűrő',
    reset: 'Visszaállít',
    apply: 'Alkalmaz',
    confirm: 'Megerősít',
    loading: 'Töltés…',
    empty: 'Nincs adat',
    error: 'Hiba',
    backToList: 'Vissza a listára',
    moreActions: 'További akciók',
    yes: 'Igen',
    no: 'Nem',
  },
  notifications: {
    title: 'Értesítések',
    markAllRead: 'Mind olvasottnak jelöl',
    empty: 'Nincs új értesítés',
  },
  roles: {
    admin: 'Adminisztrátor',
    company_owner: 'Cégvezető',
    finance_manager: 'Pénzügyi vezető',
    employee_uploader: 'Alkalmazott (feltöltő)',
    accountant: 'Könyvelő',
    readonly_auditor: 'Csak olvasás (auditor)',
  },
  warnings: {
    notOfficialVat:
      'Ez nem hivatalos ÁFA-bevallás. A megjelenített előkalkuláció könyvelői ellenőrzést igényel.',
  },
}

export type I18nKey = typeof hu
